/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedTenantsIndexRouteImport } from './routes/_authenticated/tenants/index'
import { Route as AuthenticatedTemplatesIndexRouteImport } from './routes/_authenticated/templates/index'
import { Route as AuthenticatedLeadsIndexRouteImport } from './routes/_authenticated/leads/index'
import { Route as AuthenticatedLandersIndexRouteImport } from './routes/_authenticated/landers/index'
import { Route as AuthenticatedDomainsIndexRouteImport } from './routes/_authenticated/domains/index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics/index'
import { Route as AuthenticatedAdIndexRouteImport } from './routes/_authenticated/ad/index'
import { Route as AuthenticatedTenantsNewRouteImport } from './routes/_authenticated/tenants/new'
import { Route as AuthenticatedSettingsTeamRouteImport } from './routes/_authenticated/settings/team'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedFunnelsNewRouteImport } from './routes/_authenticated/funnels/new'
import { Route as AuthenticatedDomainsNewRouteImport } from './routes/_authenticated/domains/new'
import { Route as AuthenticatedAdVerticalsRouteImport } from './routes/_authenticated/ad/verticals'
import { Route as AuthenticatedAdTestsRouteImport } from './routes/_authenticated/ad/tests'
import { Route as AuthenticatedAdStoryboardRouteImport } from './routes/_authenticated/ad/storyboard'
import { Route as AuthenticatedAdReviewRouteImport } from './routes/_authenticated/ad/review'
import { Route as AuthenticatedAdJobsRouteImport } from './routes/_authenticated/ad/jobs'
import { Route as AuthenticatedAdIntakeRouteImport } from './routes/_authenticated/ad/intake'
import { Route as AuthenticatedAdDomainsRouteImport } from './routes/_authenticated/ad/domains'
import { Route as AuthenticatedAdCreativesRouteImport } from './routes/_authenticated/ad/creatives'
import { Route as AuthenticatedAdBriefRouteImport } from './routes/_authenticated/ad/brief'
import { Route as AuthenticatedAdAccountsRouteImport } from './routes/_authenticated/ad/accounts'
import { Route as AuthenticatedDomainsDomainIdIndexRouteImport } from './routes/_authenticated/domains/$domainId/index'
import { Route as AuthenticatedAdReportsIndexRouteImport } from './routes/_authenticated/ad/reports/index'
import { Route as AuthenticatedTemplatesIdBuilderRouteImport } from './routes/_authenticated/templates/$id/builder'
import { Route as AuthenticatedLandersLanderIdEditRouteImport } from './routes/_authenticated/landers/$landerId/edit'
import { Route as AuthenticatedDomainsDomainIdLandersRouteImport } from './routes/_authenticated/domains/$domainId/landers'
import { Route as AuthenticatedDomainsDomainIdIntegrationsRouteImport } from './routes/_authenticated/domains/$domainId/integrations'
import { Route as AuthenticatedDomainsDomainIdAnalyticsRouteImport } from './routes/_authenticated/domains/$domainId/analytics'
import { Route as AuthenticatedDomainsDomainIdAccessRouteImport } from './routes/_authenticated/domains/$domainId/access'
import { Route as AuthenticatedAdReportsDomainsRouteImport } from './routes/_authenticated/ad/reports/domains'
import { Route as AuthenticatedAdReportsCreativesRouteImport } from './routes/_authenticated/ad/reports/creatives'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTenantsIndexRoute =
  AuthenticatedTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeadsIndexRoute = AuthenticatedLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLandersIndexRoute =
  AuthenticatedLandersIndexRouteImport.update({
    id: '/landers/',
    path: '/landers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDomainsIndexRoute =
  AuthenticatedDomainsIndexRouteImport.update({
    id: '/domains/',
    path: '/domains/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdIndexRoute = AuthenticatedAdIndexRouteImport.update({
  id: '/ad/',
  path: '/ad/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTenantsNewRoute = AuthenticatedTenantsNewRouteImport.update({
  id: '/tenants/new',
  path: '/tenants/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsTeamRoute =
  AuthenticatedSettingsTeamRouteImport.update({
    id: '/settings/team',
    path: '/settings/team',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFunnelsNewRoute = AuthenticatedFunnelsNewRouteImport.update({
  id: '/funnels/new',
  path: '/funnels/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDomainsNewRoute = AuthenticatedDomainsNewRouteImport.update({
  id: '/domains/new',
  path: '/domains/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdVerticalsRoute =
  AuthenticatedAdVerticalsRouteImport.update({
    id: '/ad/verticals',
    path: '/ad/verticals',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdTestsRoute = AuthenticatedAdTestsRouteImport.update({
  id: '/ad/tests',
  path: '/ad/tests',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdStoryboardRoute =
  AuthenticatedAdStoryboardRouteImport.update({
    id: '/ad/storyboard',
    path: '/ad/storyboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdReviewRoute = AuthenticatedAdReviewRouteImport.update({
  id: '/ad/review',
  path: '/ad/review',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdJobsRoute = AuthenticatedAdJobsRouteImport.update({
  id: '/ad/jobs',
  path: '/ad/jobs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdIntakeRoute = AuthenticatedAdIntakeRouteImport.update({
  id: '/ad/intake',
  path: '/ad/intake',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdDomainsRoute = AuthenticatedAdDomainsRouteImport.update({
  id: '/ad/domains',
  path: '/ad/domains',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdCreativesRoute =
  AuthenticatedAdCreativesRouteImport.update({
    id: '/ad/creatives',
    path: '/ad/creatives',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdBriefRoute = AuthenticatedAdBriefRouteImport.update({
  id: '/ad/brief',
  path: '/ad/brief',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdAccountsRoute = AuthenticatedAdAccountsRouteImport.update({
  id: '/ad/accounts',
  path: '/ad/accounts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDomainsDomainIdIndexRoute =
  AuthenticatedDomainsDomainIdIndexRouteImport.update({
    id: '/domains/$domainId/',
    path: '/domains/$domainId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdReportsIndexRoute =
  AuthenticatedAdReportsIndexRouteImport.update({
    id: '/ad/reports/',
    path: '/ad/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTemplatesIdBuilderRoute =
  AuthenticatedTemplatesIdBuilderRouteImport.update({
    id: '/templates/$id/builder',
    path: '/templates/$id/builder',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLandersLanderIdEditRoute =
  AuthenticatedLandersLanderIdEditRouteImport.update({
    id: '/landers/$landerId/edit',
    path: '/landers/$landerId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDomainsDomainIdLandersRoute =
  AuthenticatedDomainsDomainIdLandersRouteImport.update({
    id: '/domains/$domainId/landers',
    path: '/domains/$domainId/landers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDomainsDomainIdIntegrationsRoute =
  AuthenticatedDomainsDomainIdIntegrationsRouteImport.update({
    id: '/domains/$domainId/integrations',
    path: '/domains/$domainId/integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDomainsDomainIdAnalyticsRoute =
  AuthenticatedDomainsDomainIdAnalyticsRouteImport.update({
    id: '/domains/$domainId/analytics',
    path: '/domains/$domainId/analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDomainsDomainIdAccessRoute =
  AuthenticatedDomainsDomainIdAccessRouteImport.update({
    id: '/domains/$domainId/access',
    path: '/domains/$domainId/access',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdReportsDomainsRoute =
  AuthenticatedAdReportsDomainsRouteImport.update({
    id: '/ad/reports/domains',
    path: '/ad/reports/domains',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdReportsCreativesRoute =
  AuthenticatedAdReportsCreativesRouteImport.update({
    id: '/ad/reports/creatives',
    path: '/ad/reports/creatives',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/ad/accounts': typeof AuthenticatedAdAccountsRoute
  '/ad/brief': typeof AuthenticatedAdBriefRoute
  '/ad/creatives': typeof AuthenticatedAdCreativesRoute
  '/ad/domains': typeof AuthenticatedAdDomainsRoute
  '/ad/intake': typeof AuthenticatedAdIntakeRoute
  '/ad/jobs': typeof AuthenticatedAdJobsRoute
  '/ad/review': typeof AuthenticatedAdReviewRoute
  '/ad/storyboard': typeof AuthenticatedAdStoryboardRoute
  '/ad/tests': typeof AuthenticatedAdTestsRoute
  '/ad/verticals': typeof AuthenticatedAdVerticalsRoute
  '/domains/new': typeof AuthenticatedDomainsNewRoute
  '/funnels/new': typeof AuthenticatedFunnelsNewRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/tenants/new': typeof AuthenticatedTenantsNewRoute
  '/ad/': typeof AuthenticatedAdIndexRoute
  '/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/domains/': typeof AuthenticatedDomainsIndexRoute
  '/landers/': typeof AuthenticatedLandersIndexRoute
  '/leads/': typeof AuthenticatedLeadsIndexRoute
  '/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/tenants/': typeof AuthenticatedTenantsIndexRoute
  '/ad/reports/creatives': typeof AuthenticatedAdReportsCreativesRoute
  '/ad/reports/domains': typeof AuthenticatedAdReportsDomainsRoute
  '/domains/$domainId/access': typeof AuthenticatedDomainsDomainIdAccessRoute
  '/domains/$domainId/analytics': typeof AuthenticatedDomainsDomainIdAnalyticsRoute
  '/domains/$domainId/integrations': typeof AuthenticatedDomainsDomainIdIntegrationsRoute
  '/domains/$domainId/landers': typeof AuthenticatedDomainsDomainIdLandersRoute
  '/landers/$landerId/edit': typeof AuthenticatedLandersLanderIdEditRoute
  '/templates/$id/builder': typeof AuthenticatedTemplatesIdBuilderRoute
  '/ad/reports/': typeof AuthenticatedAdReportsIndexRoute
  '/domains/$domainId/': typeof AuthenticatedDomainsDomainIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/ad/accounts': typeof AuthenticatedAdAccountsRoute
  '/ad/brief': typeof AuthenticatedAdBriefRoute
  '/ad/creatives': typeof AuthenticatedAdCreativesRoute
  '/ad/domains': typeof AuthenticatedAdDomainsRoute
  '/ad/intake': typeof AuthenticatedAdIntakeRoute
  '/ad/jobs': typeof AuthenticatedAdJobsRoute
  '/ad/review': typeof AuthenticatedAdReviewRoute
  '/ad/storyboard': typeof AuthenticatedAdStoryboardRoute
  '/ad/tests': typeof AuthenticatedAdTestsRoute
  '/ad/verticals': typeof AuthenticatedAdVerticalsRoute
  '/domains/new': typeof AuthenticatedDomainsNewRoute
  '/funnels/new': typeof AuthenticatedFunnelsNewRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/tenants/new': typeof AuthenticatedTenantsNewRoute
  '/ad': typeof AuthenticatedAdIndexRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/domains': typeof AuthenticatedDomainsIndexRoute
  '/landers': typeof AuthenticatedLandersIndexRoute
  '/leads': typeof AuthenticatedLeadsIndexRoute
  '/templates': typeof AuthenticatedTemplatesIndexRoute
  '/tenants': typeof AuthenticatedTenantsIndexRoute
  '/ad/reports/creatives': typeof AuthenticatedAdReportsCreativesRoute
  '/ad/reports/domains': typeof AuthenticatedAdReportsDomainsRoute
  '/domains/$domainId/access': typeof AuthenticatedDomainsDomainIdAccessRoute
  '/domains/$domainId/analytics': typeof AuthenticatedDomainsDomainIdAnalyticsRoute
  '/domains/$domainId/integrations': typeof AuthenticatedDomainsDomainIdIntegrationsRoute
  '/domains/$domainId/landers': typeof AuthenticatedDomainsDomainIdLandersRoute
  '/landers/$landerId/edit': typeof AuthenticatedLandersLanderIdEditRoute
  '/templates/$id/builder': typeof AuthenticatedTemplatesIdBuilderRoute
  '/ad/reports': typeof AuthenticatedAdReportsIndexRoute
  '/domains/$domainId': typeof AuthenticatedDomainsDomainIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/ad/accounts': typeof AuthenticatedAdAccountsRoute
  '/_authenticated/ad/brief': typeof AuthenticatedAdBriefRoute
  '/_authenticated/ad/creatives': typeof AuthenticatedAdCreativesRoute
  '/_authenticated/ad/domains': typeof AuthenticatedAdDomainsRoute
  '/_authenticated/ad/intake': typeof AuthenticatedAdIntakeRoute
  '/_authenticated/ad/jobs': typeof AuthenticatedAdJobsRoute
  '/_authenticated/ad/review': typeof AuthenticatedAdReviewRoute
  '/_authenticated/ad/storyboard': typeof AuthenticatedAdStoryboardRoute
  '/_authenticated/ad/tests': typeof AuthenticatedAdTestsRoute
  '/_authenticated/ad/verticals': typeof AuthenticatedAdVerticalsRoute
  '/_authenticated/domains/new': typeof AuthenticatedDomainsNewRoute
  '/_authenticated/funnels/new': typeof AuthenticatedFunnelsNewRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/_authenticated/tenants/new': typeof AuthenticatedTenantsNewRoute
  '/_authenticated/ad/': typeof AuthenticatedAdIndexRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/domains/': typeof AuthenticatedDomainsIndexRoute
  '/_authenticated/landers/': typeof AuthenticatedLandersIndexRoute
  '/_authenticated/leads/': typeof AuthenticatedLeadsIndexRoute
  '/_authenticated/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/_authenticated/tenants/': typeof AuthenticatedTenantsIndexRoute
  '/_authenticated/ad/reports/creatives': typeof AuthenticatedAdReportsCreativesRoute
  '/_authenticated/ad/reports/domains': typeof AuthenticatedAdReportsDomainsRoute
  '/_authenticated/domains/$domainId/access': typeof AuthenticatedDomainsDomainIdAccessRoute
  '/_authenticated/domains/$domainId/analytics': typeof AuthenticatedDomainsDomainIdAnalyticsRoute
  '/_authenticated/domains/$domainId/integrations': typeof AuthenticatedDomainsDomainIdIntegrationsRoute
  '/_authenticated/domains/$domainId/landers': typeof AuthenticatedDomainsDomainIdLandersRoute
  '/_authenticated/landers/$landerId/edit': typeof AuthenticatedLandersLanderIdEditRoute
  '/_authenticated/templates/$id/builder': typeof AuthenticatedTemplatesIdBuilderRoute
  '/_authenticated/ad/reports/': typeof AuthenticatedAdReportsIndexRoute
  '/_authenticated/domains/$domainId/': typeof AuthenticatedDomainsDomainIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/dashboard'
    | '/onboarding'
    | '/ad/accounts'
    | '/ad/brief'
    | '/ad/creatives'
    | '/ad/domains'
    | '/ad/intake'
    | '/ad/jobs'
    | '/ad/review'
    | '/ad/storyboard'
    | '/ad/tests'
    | '/ad/verticals'
    | '/domains/new'
    | '/funnels/new'
    | '/settings/profile'
    | '/settings/team'
    | '/tenants/new'
    | '/ad/'
    | '/analytics/'
    | '/domains/'
    | '/landers/'
    | '/leads/'
    | '/templates/'
    | '/tenants/'
    | '/ad/reports/creatives'
    | '/ad/reports/domains'
    | '/domains/$domainId/access'
    | '/domains/$domainId/analytics'
    | '/domains/$domainId/integrations'
    | '/domains/$domainId/landers'
    | '/landers/$landerId/edit'
    | '/templates/$id/builder'
    | '/ad/reports/'
    | '/domains/$domainId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/dashboard'
    | '/onboarding'
    | '/ad/accounts'
    | '/ad/brief'
    | '/ad/creatives'
    | '/ad/domains'
    | '/ad/intake'
    | '/ad/jobs'
    | '/ad/review'
    | '/ad/storyboard'
    | '/ad/tests'
    | '/ad/verticals'
    | '/domains/new'
    | '/funnels/new'
    | '/settings/profile'
    | '/settings/team'
    | '/tenants/new'
    | '/ad'
    | '/analytics'
    | '/domains'
    | '/landers'
    | '/leads'
    | '/templates'
    | '/tenants'
    | '/ad/reports/creatives'
    | '/ad/reports/domains'
    | '/domains/$domainId/access'
    | '/domains/$domainId/analytics'
    | '/domains/$domainId/integrations'
    | '/domains/$domainId/landers'
    | '/landers/$landerId/edit'
    | '/templates/$id/builder'
    | '/ad/reports'
    | '/domains/$domainId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/sign-in'
    | '/sign-up'
    | '/_authenticated/dashboard'
    | '/_authenticated/onboarding'
    | '/_authenticated/ad/accounts'
    | '/_authenticated/ad/brief'
    | '/_authenticated/ad/creatives'
    | '/_authenticated/ad/domains'
    | '/_authenticated/ad/intake'
    | '/_authenticated/ad/jobs'
    | '/_authenticated/ad/review'
    | '/_authenticated/ad/storyboard'
    | '/_authenticated/ad/tests'
    | '/_authenticated/ad/verticals'
    | '/_authenticated/domains/new'
    | '/_authenticated/funnels/new'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/team'
    | '/_authenticated/tenants/new'
    | '/_authenticated/ad/'
    | '/_authenticated/analytics/'
    | '/_authenticated/domains/'
    | '/_authenticated/landers/'
    | '/_authenticated/leads/'
    | '/_authenticated/templates/'
    | '/_authenticated/tenants/'
    | '/_authenticated/ad/reports/creatives'
    | '/_authenticated/ad/reports/domains'
    | '/_authenticated/domains/$domainId/access'
    | '/_authenticated/domains/$domainId/analytics'
    | '/_authenticated/domains/$domainId/integrations'
    | '/_authenticated/domains/$domainId/landers'
    | '/_authenticated/landers/$landerId/edit'
    | '/_authenticated/templates/$id/builder'
    | '/_authenticated/ad/reports/'
    | '/_authenticated/domains/$domainId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/': {
      id: '/_authenticated/tenants/'
      path: '/tenants'
      fullPath: '/tenants/'
      preLoaderRoute: typeof AuthenticatedTenantsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/templates/': {
      id: '/_authenticated/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leads/': {
      id: '/_authenticated/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AuthenticatedLeadsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/landers/': {
      id: '/_authenticated/landers/'
      path: '/landers'
      fullPath: '/landers/'
      preLoaderRoute: typeof AuthenticatedLandersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains/': {
      id: '/_authenticated/domains/'
      path: '/domains'
      fullPath: '/domains/'
      preLoaderRoute: typeof AuthenticatedDomainsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/': {
      id: '/_authenticated/ad/'
      path: '/ad'
      fullPath: '/ad/'
      preLoaderRoute: typeof AuthenticatedAdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/new': {
      id: '/_authenticated/tenants/new'
      path: '/tenants/new'
      fullPath: '/tenants/new'
      preLoaderRoute: typeof AuthenticatedTenantsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/team': {
      id: '/_authenticated/settings/team'
      path: '/settings/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/funnels/new': {
      id: '/_authenticated/funnels/new'
      path: '/funnels/new'
      fullPath: '/funnels/new'
      preLoaderRoute: typeof AuthenticatedFunnelsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains/new': {
      id: '/_authenticated/domains/new'
      path: '/domains/new'
      fullPath: '/domains/new'
      preLoaderRoute: typeof AuthenticatedDomainsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/verticals': {
      id: '/_authenticated/ad/verticals'
      path: '/ad/verticals'
      fullPath: '/ad/verticals'
      preLoaderRoute: typeof AuthenticatedAdVerticalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/tests': {
      id: '/_authenticated/ad/tests'
      path: '/ad/tests'
      fullPath: '/ad/tests'
      preLoaderRoute: typeof AuthenticatedAdTestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/storyboard': {
      id: '/_authenticated/ad/storyboard'
      path: '/ad/storyboard'
      fullPath: '/ad/storyboard'
      preLoaderRoute: typeof AuthenticatedAdStoryboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/review': {
      id: '/_authenticated/ad/review'
      path: '/ad/review'
      fullPath: '/ad/review'
      preLoaderRoute: typeof AuthenticatedAdReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/jobs': {
      id: '/_authenticated/ad/jobs'
      path: '/ad/jobs'
      fullPath: '/ad/jobs'
      preLoaderRoute: typeof AuthenticatedAdJobsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/intake': {
      id: '/_authenticated/ad/intake'
      path: '/ad/intake'
      fullPath: '/ad/intake'
      preLoaderRoute: typeof AuthenticatedAdIntakeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/domains': {
      id: '/_authenticated/ad/domains'
      path: '/ad/domains'
      fullPath: '/ad/domains'
      preLoaderRoute: typeof AuthenticatedAdDomainsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/creatives': {
      id: '/_authenticated/ad/creatives'
      path: '/ad/creatives'
      fullPath: '/ad/creatives'
      preLoaderRoute: typeof AuthenticatedAdCreativesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/brief': {
      id: '/_authenticated/ad/brief'
      path: '/ad/brief'
      fullPath: '/ad/brief'
      preLoaderRoute: typeof AuthenticatedAdBriefRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/accounts': {
      id: '/_authenticated/ad/accounts'
      path: '/ad/accounts'
      fullPath: '/ad/accounts'
      preLoaderRoute: typeof AuthenticatedAdAccountsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains/$domainId/': {
      id: '/_authenticated/domains/$domainId/'
      path: '/domains/$domainId'
      fullPath: '/domains/$domainId/'
      preLoaderRoute: typeof AuthenticatedDomainsDomainIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/reports/': {
      id: '/_authenticated/ad/reports/'
      path: '/ad/reports'
      fullPath: '/ad/reports/'
      preLoaderRoute: typeof AuthenticatedAdReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/templates/$id/builder': {
      id: '/_authenticated/templates/$id/builder'
      path: '/templates/$id/builder'
      fullPath: '/templates/$id/builder'
      preLoaderRoute: typeof AuthenticatedTemplatesIdBuilderRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/landers/$landerId/edit': {
      id: '/_authenticated/landers/$landerId/edit'
      path: '/landers/$landerId/edit'
      fullPath: '/landers/$landerId/edit'
      preLoaderRoute: typeof AuthenticatedLandersLanderIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains/$domainId/landers': {
      id: '/_authenticated/domains/$domainId/landers'
      path: '/domains/$domainId/landers'
      fullPath: '/domains/$domainId/landers'
      preLoaderRoute: typeof AuthenticatedDomainsDomainIdLandersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains/$domainId/integrations': {
      id: '/_authenticated/domains/$domainId/integrations'
      path: '/domains/$domainId/integrations'
      fullPath: '/domains/$domainId/integrations'
      preLoaderRoute: typeof AuthenticatedDomainsDomainIdIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains/$domainId/analytics': {
      id: '/_authenticated/domains/$domainId/analytics'
      path: '/domains/$domainId/analytics'
      fullPath: '/domains/$domainId/analytics'
      preLoaderRoute: typeof AuthenticatedDomainsDomainIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains/$domainId/access': {
      id: '/_authenticated/domains/$domainId/access'
      path: '/domains/$domainId/access'
      fullPath: '/domains/$domainId/access'
      preLoaderRoute: typeof AuthenticatedDomainsDomainIdAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/reports/domains': {
      id: '/_authenticated/ad/reports/domains'
      path: '/ad/reports/domains'
      fullPath: '/ad/reports/domains'
      preLoaderRoute: typeof AuthenticatedAdReportsDomainsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ad/reports/creatives': {
      id: '/_authenticated/ad/reports/creatives'
      path: '/ad/reports/creatives'
      fullPath: '/ad/reports/creatives'
      preLoaderRoute: typeof AuthenticatedAdReportsCreativesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedAdAccountsRoute: typeof AuthenticatedAdAccountsRoute
  AuthenticatedAdBriefRoute: typeof AuthenticatedAdBriefRoute
  AuthenticatedAdCreativesRoute: typeof AuthenticatedAdCreativesRoute
  AuthenticatedAdDomainsRoute: typeof AuthenticatedAdDomainsRoute
  AuthenticatedAdIntakeRoute: typeof AuthenticatedAdIntakeRoute
  AuthenticatedAdJobsRoute: typeof AuthenticatedAdJobsRoute
  AuthenticatedAdReviewRoute: typeof AuthenticatedAdReviewRoute
  AuthenticatedAdStoryboardRoute: typeof AuthenticatedAdStoryboardRoute
  AuthenticatedAdTestsRoute: typeof AuthenticatedAdTestsRoute
  AuthenticatedAdVerticalsRoute: typeof AuthenticatedAdVerticalsRoute
  AuthenticatedDomainsNewRoute: typeof AuthenticatedDomainsNewRoute
  AuthenticatedFunnelsNewRoute: typeof AuthenticatedFunnelsNewRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsTeamRoute: typeof AuthenticatedSettingsTeamRoute
  AuthenticatedTenantsNewRoute: typeof AuthenticatedTenantsNewRoute
  AuthenticatedAdIndexRoute: typeof AuthenticatedAdIndexRoute
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
  AuthenticatedDomainsIndexRoute: typeof AuthenticatedDomainsIndexRoute
  AuthenticatedLandersIndexRoute: typeof AuthenticatedLandersIndexRoute
  AuthenticatedLeadsIndexRoute: typeof AuthenticatedLeadsIndexRoute
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute
  AuthenticatedTenantsIndexRoute: typeof AuthenticatedTenantsIndexRoute
  AuthenticatedAdReportsCreativesRoute: typeof AuthenticatedAdReportsCreativesRoute
  AuthenticatedAdReportsDomainsRoute: typeof AuthenticatedAdReportsDomainsRoute
  AuthenticatedDomainsDomainIdAccessRoute: typeof AuthenticatedDomainsDomainIdAccessRoute
  AuthenticatedDomainsDomainIdAnalyticsRoute: typeof AuthenticatedDomainsDomainIdAnalyticsRoute
  AuthenticatedDomainsDomainIdIntegrationsRoute: typeof AuthenticatedDomainsDomainIdIntegrationsRoute
  AuthenticatedDomainsDomainIdLandersRoute: typeof AuthenticatedDomainsDomainIdLandersRoute
  AuthenticatedLandersLanderIdEditRoute: typeof AuthenticatedLandersLanderIdEditRoute
  AuthenticatedTemplatesIdBuilderRoute: typeof AuthenticatedTemplatesIdBuilderRoute
  AuthenticatedAdReportsIndexRoute: typeof AuthenticatedAdReportsIndexRoute
  AuthenticatedDomainsDomainIdIndexRoute: typeof AuthenticatedDomainsDomainIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedAdAccountsRoute: AuthenticatedAdAccountsRoute,
  AuthenticatedAdBriefRoute: AuthenticatedAdBriefRoute,
  AuthenticatedAdCreativesRoute: AuthenticatedAdCreativesRoute,
  AuthenticatedAdDomainsRoute: AuthenticatedAdDomainsRoute,
  AuthenticatedAdIntakeRoute: AuthenticatedAdIntakeRoute,
  AuthenticatedAdJobsRoute: AuthenticatedAdJobsRoute,
  AuthenticatedAdReviewRoute: AuthenticatedAdReviewRoute,
  AuthenticatedAdStoryboardRoute: AuthenticatedAdStoryboardRoute,
  AuthenticatedAdTestsRoute: AuthenticatedAdTestsRoute,
  AuthenticatedAdVerticalsRoute: AuthenticatedAdVerticalsRoute,
  AuthenticatedDomainsNewRoute: AuthenticatedDomainsNewRoute,
  AuthenticatedFunnelsNewRoute: AuthenticatedFunnelsNewRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsTeamRoute: AuthenticatedSettingsTeamRoute,
  AuthenticatedTenantsNewRoute: AuthenticatedTenantsNewRoute,
  AuthenticatedAdIndexRoute: AuthenticatedAdIndexRoute,
  AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
  AuthenticatedDomainsIndexRoute: AuthenticatedDomainsIndexRoute,
  AuthenticatedLandersIndexRoute: AuthenticatedLandersIndexRoute,
  AuthenticatedLeadsIndexRoute: AuthenticatedLeadsIndexRoute,
  AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
  AuthenticatedTenantsIndexRoute: AuthenticatedTenantsIndexRoute,
  AuthenticatedAdReportsCreativesRoute: AuthenticatedAdReportsCreativesRoute,
  AuthenticatedAdReportsDomainsRoute: AuthenticatedAdReportsDomainsRoute,
  AuthenticatedDomainsDomainIdAccessRoute:
    AuthenticatedDomainsDomainIdAccessRoute,
  AuthenticatedDomainsDomainIdAnalyticsRoute:
    AuthenticatedDomainsDomainIdAnalyticsRoute,
  AuthenticatedDomainsDomainIdIntegrationsRoute:
    AuthenticatedDomainsDomainIdIntegrationsRoute,
  AuthenticatedDomainsDomainIdLandersRoute:
    AuthenticatedDomainsDomainIdLandersRoute,
  AuthenticatedLandersLanderIdEditRoute: AuthenticatedLandersLanderIdEditRoute,
  AuthenticatedTemplatesIdBuilderRoute: AuthenticatedTemplatesIdBuilderRoute,
  AuthenticatedAdReportsIndexRoute: AuthenticatedAdReportsIndexRoute,
  AuthenticatedDomainsDomainIdIndexRoute:
    AuthenticatedDomainsDomainIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
